import { intersection } from 'lodash';

import { availableIds } from './constants';

export default function loadCompetitorBg(
    ids: string[],
    isMobile: boolean
): Promise<string | undefined> | null {
    const firstId = intersection(availableIds, ids)[0] as
        | typeof availableIds[number]
        | undefined;

    if (!firstId) return null;

    let promise: Promise<{ default: { [key: string]: string } }>;

    if (isMobile) {
        promise = import(
            /* webpackChunkName: "competitor-bg-mob-dark" */ './mob/dark'
        );
    } else {
        promise = import(/* webpackChunkName: "competitor-bg-dark" */ './dark');
    }

    return promise.then(mapping => mapping.default[firstId]);
}
